const modules = {
	SFDC: 'Salesforce App',
	Lists: 'Lists',
	Reports: 'Reports',
	ReportsFactory: 'Reports Factory',
	Settings: 'Settings',
	Portfolio: 'My Portfolio',
	Tasks: 'Tasks',
	Notifications: 'Notifications',
	HealthConsole: 'Health Console',
	ExecutiveConsole: 'Executive Console',
	Accounts: 'Accounts',
	Forms: 'Forms',
	SuccessPlay: 'SuccessPlay',
	SuccessBloc: 'SuccessBloc',
	Campaigns: 'Campaigns',
	WhatsNew: "What's new",
	Revenue: 'Revenue Center',
	Segments: 'Segments',
	ZoeAdmin: 'Admin',
	ImpactStep: 'Impact Step',
	Share: 'Share',
	Spark: 'Spark',
	System: '__SYSTEM',
	IntegrationHub: 'Integration Hub',
	Agenda: ' Agenda',
	OSP: 'OSP',
	Plans: 'Plans',
	ZoeWeb: 'Zoe Web',
	ZoeSFDC: 'Zoe SFDC',
	Pricing: 'Pricing',
	GlobalInvite: 'Global Invite',
	Trial: 'Trial',
	Touchpoint: 'Touchpoint',
	SetupTab: 'Setup Tab',
	MarketplaceSuccessBLOC: 'Marketplace SuccessBLOC',
	Signals: 'Signals',
	Global: 'Global',
	HelpPanel: 'Help Panel',
	Canvas: 'Canvas',
	HealthDesigner: 'Health Designer',
	SettingsHome: 'Settings Home',
	SettingsHomeVisits: 'Settings Home Visits',
	Archive: 'Archive',
	ObjectiveLibrary: 'Objective Library',
	LearningPanel: 'Learning Panel',
	eCommerceInApp: 'e-commerce in-app',
	PresentationGenerator: 'Presentation Generator',
	AI: 'AI',
	TrialOnboarding: 'Trial Onboarding',
	ReportBuilder: 'Report Builder',
	InApp: 'In-App Instrumentation',
	HierarchyCalculations: 'Hierarchy Calculations',
};

/**
 * track activity
 *
 * 'org' and 'user' params are optional, use only when you want to override the current 'org' and 'user' info.
 *
 * @param activity
 * @param moduleKey
 * @param org [Optional]
 * @param user [Optional]
 */
const track = (activity, moduleKey, org, user) => {
	const { totangoTracker } = window;
	if (!totangoTracker) {
		return;
	}

	const moduleName = modules[moduleKey];
	if (!moduleName) {
		return;
	}
	totangoTracker.module = moduleName;
	totangoTracker.track(activity, moduleName, org, user);
};

/**
 * identify user
 * @param org the service id
 * @param user can be an object (with user attribtues) or the user id.
 */
export const identify = (org, user) => {
	const { totangoTracker } = window;
	if (!totangoTracker) {
		return;
	}
	totangoTracker.identify(org, user);
};

export default track;
